import React, { useState } from 'react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoginMutation } from '../../entities/session/api/sessionApi';
import { useToast } from '../../hooks/useToast';
import { AuthPanel } from '../../components/AuthPanel/AuthPanel';
import type { Credentials } from '../../components/AuthPanel/AuthPanel';
import { BrandPanel } from '../../components/BrandPanel/BrandPanel';
import { QrModal } from '../../components/QrModal/QrModal';
import { Toast } from '../../components/Toast/Toast';
import styles from './LoginPage.module.scss';
import { isAccessRestricted } from '../../utils/isAccessRestricted';
import { MaintenanceModal } from '../../components/access/MaintenanceModal/MaintenanceModal';

const DEFAULT_ROUTE = '/';

export const LoginPage: FC = () => {
    const [qrOpen, setQrOpen] = useState(false);
    const [maintenanceOpen, setMaintenanceOpen] = useState(false);
    const { message, visible, showToast } = useToast();

    const navigate = useNavigate();
    const [login, { isLoading }] = useLoginMutation();

    const handleSubmit = async ({ email, password }: Credentials): Promise<void> => {
        try {
            await login({ email, password }).unwrap();
            navigate(DEFAULT_ROUTE, { replace: true });
        } catch (error) {
            if (isAccessRestricted(error)) {
                setMaintenanceOpen(true);
            }
            // остальные ошибки notifyError
        }
    };

    return (
        <>
            <main className={styles.page}>
                <BrandPanel onOpenQr={() => setQrOpen(true)} />

                <AuthPanel
                    onSubmit={handleSubmit}
                    submitting={isLoading}
                    onForgotPassword={() => navigate('/reset-password')}
                />
            </main>

            <QrModal open={qrOpen} onClose={() => setQrOpen(false)} />
            <MaintenanceModal open={maintenanceOpen} onClose={() => setMaintenanceOpen(false)} />
            <Toast message={message} visible={visible} />
        </>
    );
};